<script setup>
  import {
    computed,
    nextTick,
    onMounted,
    ref
  } from 'vue'

  import ModalMessage from '@components/ModalMessage.vue'
  import Pagination from '@components/Pagination.vue'
  import Property from '@components/PropertyLarge.vue'

  import { useI18n } from '@shared/i18n.js'
  import { useAjax } from '@composables/useAjax.js'
  import { usePropertiesEnquiry } from '@composables/usePropertiesEnquiry.js'
  import {
    generateUrl,
    pageTop
  } from '@shared/util.js'

  const current = ref([])
  const page = ref(1)
  const rents = ref(null)
  const sales = ref(null)
  const type = ref('sale')

  const per = window.app.page.per

  const { t, vt } = useI18n('welcome.index.js')
  const { callGet } = useAjax()
  const {
    enquiryPath,
    overSelected,
    selected,
    handleCheckProperty
  } = usePropertiesEnquiry()


  onMounted(() => {
    getProperties()
  })

  const properties = computed(() => type.value == 'sale' ? sales.value : rents.value)

  /**
   * タブの切替
   */
  const handleClickTab = (val) => {
    if (type.value != val && (val == 'sale' ? sales : rents).value.length > 0) {
      type.value = val
      refresh(false)
    }
  }

  /**
   * ページ移動
   */
  const handleMovePage = (value) => refresh(true)

  /**
   * 物件情報の取得（全体）
   */
  const getProperties = async () => {
    const response = await callGet(window.app.page.properties_path)

    if (response.rents && response.rents.length > 0) {
      rents.value = response.rents
    }
    else {
      rents.value = []
    }

    if (response.sales && response.sales.length > 0) {
      sales.value = response.sales
      refresh(false)
    }
    else {
      sales.value = []
      if (rents.value.length > 0) {
        type.value = 'rent'
        refresh(false)
      }
    }
  }

  /**
   * 物件一覧の表示
   * 表示対象のページの物件情報をajaxで取得する
   */
  const refresh = (scroll = false) => {
    const target = properties.value.slice(per * (page.value - 1), per * page.value)
    Promise.allSettled(target.map((property) => callGet(property.path)))
      .then((results) => {
        current.value = results.filter((result) => result.status == 'fulfilled').map((result) => result.value.property)
        current.value.forEach((property) => property.selected = false)
      })

    if (scroll) {
      $('body, html').animate({ scrollTop: $("#agent-properties").offset().top - 100 }, 100)
    }
  }
</script>

<template>
  <template v-if="rents">
    <ul class="list_tab">
      <li :class="{ select: type == 'sale' }" class="list_tab_item" @click="handleClickTab('sale')">{{ t('c.sale') }}（{{ sales.length }}）</li>
      <li :class="{ select: type == 'rent' }" class="list_tab_item" @click="handleClickTab('rent')">{{ t('c.rent') }}（{{ rents.length }}）</li>
    </ul>
    <div class="">
      <div class="property_list">
        <div class="listing">
          <template v-for="(property, index) in current" :key="`property-${property.code}`">
            <Property
              :property="property"
              @check="handleCheckProperty(property, current)"
            />
          </template>
        </div>
        <Pagination v-model="page" :per="per" :total="properties.length" @move="handleMovePage" />
      </div>
    </div>

    <div :class="{ 'is-active': selected.length > 0 }" class="content_small -properties" id="fixed_contact_links">
      <a :href="enquiryPath" class="btn">{{ t('enquiries.show.js.contact_agent') }}（<span class="num">{{ selected.length }}</span>）</a>
    </div>

    <ModalMessage
      v-model="overSelected"
      :message="t('properties.index.js.over_selected')"
    />
  </template>
</template>

<style>
  .content_small.-properties {
    z-index: 10 !important;
  }

  .slick-slide {
    height: auto;
  }
</style>
